import { LocationSurchargeMapper } from "./location-surcharge/location-surcharge.mapper";

import { Location } from "./location.model";
import { LocationAliasMapper } from "./location-alias/location-alias.mapper";

export class LocationMapper {
  public static map(data: any): Location {
    if (!data) {
      return null;
    }

    return new Location(
      data.id,
      data.name,
      data.kind,
      data.surcharges
        ? data.surcharges.map((surcharge) =>
            LocationSurchargeMapper.map(surcharge),
          )
        : null,
      data.code,
      data.rkstCode,
      data.ecuCode,
      data.cmaCode,
      data.country,
      data.region,
      typeof data.latitude === "string"
        ? parseFloat(data.latitude)
        : data.latitude,
      typeof data.longitude === "string"
        ? parseFloat(data.longitude)
        : data.longitude,
      data.availableOnline,
      [],
      data.aliases
        ? data.aliases.map((alias) => LocationAliasMapper.map(alias))
        : null,
      data.active,
      data.termsLocales && data.termsLocales.length ? data.termsLocales : null,
    );
  }
}
